import { render, staticRenderFns } from "./customerOrderEvaluation.vue?vue&type=template&id=118cf5f5&scoped=true&"
import script from "./customerOrderEvaluation.vue?vue&type=script&lang=js&"
export * from "./customerOrderEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./customerOrderEvaluation.vue?vue&type=style&index=0&id=118cf5f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118cf5f5",
  null
  
)

export default component.exports